var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpotify(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.51 0C7.85001 0 0.0100098 7.83 0.0100098 17.5C0.0100098 27.17 7.85001 35 17.51 35C27.18 35 35.01 27.17 35.01 17.5C35.01 7.84 27.18 0 17.51 0ZM25.53 25.24C25.22 25.75 24.54 25.92 24.03 25.6C19.92 23.09 14.75 22.52 8.66002 23.91C8.07002 24.04 7.49002 23.68 7.35002 23.09C7.22002 22.5 7.58001 21.92 8.17001 21.78C14.84 20.26 20.55 20.91 25.17 23.73C25.69 24.05 25.85 24.73 25.53 25.24ZM27.68 20.47C27.29 21.11 26.45 21.31 25.8 20.92C21.1 18.03 13.93 17.19 8.36002 18.88C7.64002 19.1 6.88002 18.69 6.66002 17.97C6.44002 17.25 6.85002 16.49 7.57002 16.27C13.93 14.34 21.83 15.28 27.23 18.6C27.87 18.99 28.07 19.83 27.68 20.47ZM27.86 15.51C22.22 12.16 12.91 11.85 7.53001 13.49C6.66001 13.75 5.75002 13.26 5.49002 12.4C5.23002 11.53 5.72002 10.62 6.58002 10.36C12.76 8.48 23.04 8.85 29.53 12.7C30.31 13.16 30.56 14.17 30.1 14.94C29.64 15.72 28.64 15.98 27.86 15.51Z",
    fill: "url(#paint0_linear_18_9)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18_9",
    x1: -101.18,
    y1: 136.19,
    x2: 100.153,
    y2: -65.1436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FEC978"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFB3DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#55E1FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotify);
export default __webpack_public_path__ + "static/media/spotify.ebde227ed7b9a331a40b4e47bf2fdf2e.svg";
export { ForwardRef as ReactComponent };